import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL, USER_URL } from "../../constant/api";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AdminAddBrand() {
    const [brands, setBrands] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const [brand, setBrand] = useState({
    brandName: "",
    logo: "",
    logoFile: null,
    advertisement: "",
    advertisementFile: null,
  });

  const fetchBrands = async () => {
    try {
      const response = await USER_URL.get(`/products/admin/brands/`);
      setBrands(response.data.data || []);
    } catch (error) {
      toast.error("Error fetching brands!");
      console.error("Error fetching brands:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBrand((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setBrand((prev) => ({
          ...prev,
          [field]: reader.result,
          [`${field}File`]: file,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!brand.brandName || !brand.logoFile || !brand.advertisementFile) {
      toast.warn("All fields are required!");
      return;
    }

    const formData = new FormData();
    formData.append("brandname", brand.brandName);
    formData.append("image", brand.logoFile);
    formData.append("brand_banner", brand.advertisementFile);

    try {
      setIsSubmitting(true);
      await USER_URL.post(`/products/admin/brands/`, formData);
      toast.success("Brand submitted successfully!");
      fetchBrands();
      setBrand({
        brandName: "",
        logo: "",
        logoFile: null,
        advertisement: "",
        advertisementFile: null,
      });
    } catch (error) {
      console.error("Error submitting brand:", error);
      toast.error(
        error.response?.data?.message || "Failed to submit brand. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    fetchBrands();
  }, []);
  return (
    <div className="p-3">
      <ToastContainer position="top-center" autoClose={3000} />
      <h1 className="text-2xl font-medium text-green-600 ">Admin Create Brand</h1>
      <div className="border-2 rounded-lg shadow-lg bg-gray-50 p-6">
        <h2 className="text-green-700 text-3xl font-bold text-center mb-6">
          Create Brand
        </h2>

        <form onSubmit={handleSubmit} className="space-y-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Brand Name
              </label>
              <input
                type="text"
                name="brandName"
                value={brand.brandName}
                onChange={handleInputChange}
                placeholder="Enter brand name"
                className="w-full border-gray-300 border p-3 rounded focus:outline-none focus:ring focus:ring-green-200"
              />
            </div>

            <div className="grid justify-end">
              <label className="block text-gray-700 font-medium mb-2">Logo</label>
              <div className="flex items-center space-x-4">
                <div className="w-24 h-24 border-2 rounded-lg flex items-center justify-center overflow-hidden bg-gray-100">
                  {brand.logo ? (
                    <img
                      src={brand.logo}
                      alt="Logo Preview"
                      className="h-full w-full object-cover"
                    />
                  ) : (
                    <span className="text-gray-500 text-sm">No Logo</span>
                  )}
                </div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, "logo")}
                  className="hidden"
                  id="logoUpload"
                />
                <label
                  htmlFor="logoUpload"
                  className="bg-green-600 text-white px-4 py-2 rounded cursor-pointer hover:bg-green-700"
                >
                  Upload Logo
                </label>
              </div>
            </div>
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Banner Image
            </label>
            <div className="h-56 w-full border-2 rounded-lg flex items-center justify-center overflow-hidden bg-gray-100">
              {brand.advertisement ? (
                <img
                  src={brand.advertisement}
                  alt="Advertisement Preview"
                  className="h-full w-full object-cover"
                />
              ) : (
                <span className="text-gray-500 text-sm">No Banner</span>
              )}
            </div>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, "advertisement")}
              className="hidden"
              id="advertisementUpload"
            />
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mt-6">
            <label
              htmlFor="advertisementUpload"
              className="w-full md:w-[250px] border-2 border-green-600 text-green-600 text-center py-2 px-4 rounded cursor-pointer hover:bg-green-600 hover:text-white transition"
            >
              Add Banner
            </label>
            <button
              type="submit"
              disabled={isSubmitting}
              className={`w-full md:w-[250px] bg-green-600 text-white py-2 px-6 rounded transition ${
                isSubmitting ? "opacity-50 cursor-not-allowed" : "hover:bg-green-700"
              }`}
            >
              {isSubmitting ? "Submitting..." : "Confirm Submission"}
            </button>
          </div>
        </form>

        {/* Back Button */}
        <div className="mt-4 text-center">
          <button
            onClick={() => navigate(-1)}
            className="text-green-600 hover:text-green-700 font-medium text-sm"
          >
            &lt; Back to Brand List
          </button>
        </div>
      </div>
    </div>
  )
}

export default AdminAddBrand